import React from 'react';
import { Alert, Box, Button, Chip, Stack, TextField, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import GlobalDialog from '../../../components/mui/Dialogue/GlobalDialog';
import { useSelector } from 'react-redux';
import { getCoursePurchaseRequest, rejectRequest } from '../../../redux/features/studentPortalSlice';
import { Form, FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup';

export default function RequestRejection({ rowData, open, setOpen }) {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  // const [open, setOpen] = React.useState(false);

  const { loading } = useSelector((state) => state.studentPortal);

  const validationSchema = Yup.object().shape({
    remarks: Yup.string().required('Rejection remarks is required'),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      remarks: '',
      request_id: rowData?.id,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const payload = {
        remarks: values.remarks,
        request_id: values.request_id,
      };
      dispatch(rejectRequest(payload)).then((res) => {
        if (res.payload.status === 'success') {
          enqueueSnackbar(res.payload.message, {
            variant: 'success',
          });
          dispatch(getCoursePurchaseRequest());
          setOpen(false);
        } else {
          enqueueSnackbar(res.payload.message, {
            variant: 'error',
          });
          // setOpen(false);
        }
      });
    },
  });

  return (
    <>
      <GlobalDialog
        title={'Reject Request'}
        open={open}
        setOpen={setOpen}
        fullWidth
        maxWidth={'xs'}
        closeButton={true}
        content={
          <>
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Box>
                  <Stack direction={'column'} spacing={2}>
                    <TextField
                      name="remarks"
                      type="text"
                      rows={2}
                      multiline
                      value={formik.values.remarks}
                      error={formik.touched.remarks && Boolean(formik.errors.remarks)}
                      helperText={formik.errors.remarks}
                      onChange={formik.handleChange}
                      placeholder='Type rejection remarks here...'
                      fullWidth
                      label="Remarks"
                    />
                  </Stack>
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', pt: 2 }}>
                    <Stack direction={'row'} spacing={1}>
                      <Button size="small" variant="outlined" color="secondary" onClick={() => setOpen(false)}>
                        Cancel
                      </Button>
                      <Button disabled={loading} variant="contained" color="secondary" size="small" type="submit">
                        {loading ? 'Please wait...' : 'Reject'}
                      </Button>
                    </Stack>
                  </Box>
                </Box>
              </Form>
            </FormikProvider>
          </>
        }
      />
    </>
  );
}
